import Axios from 'axios';
export const uploadToS3 = (url, file) => Axios.put(url, file);
export const getFromS3 = url => Axios.get(url);